import { Screen } from '~/screens/top-banners/new';

export const TopBannersNew: React.FC = () => <Screen />;
